
  import { Vue, Component, Prop } from "vue-property-decorator";

  import FormInputGroup from "@/components/form/FormInputGroup.vue";

  @Component({
    components: {
      FormInputGroup,
    },
  })
  export default class InputRangeFilter extends Vue {
    @Prop({ type: [String, Number], default: "" }) minValue!: string | number;
    @Prop({ type: [String, Number], default: "" }) maxValue!: string | number;
    @Prop({ type: String, default: undefined }) readonly inputClasses?: string;
    @Prop({ type: String, default: undefined }) readonly prefix?: string;
    @Prop({ type: String, default: undefined }) readonly suffix?: string;
    @Prop({ type: Boolean, default: '' }) readonly suffixClasses?: string;
    @Prop({ type: Boolean, default: '' }) readonly prefixClasses?: string;
     @Prop({ type: String, default: undefined }) readonly inputClass?: string;
    @Prop({ type: Boolean, default: 'Min' }) readonly leftPlaceholder?: string;
    @Prop({ type: Boolean, default: 'Max' }) readonly rightPlaceholder?: string;

    handleInput(name: string, value: string) {
      if (value == "0") {
        value = "";
      }
      if (parseInt(value) < 0) {
        value = "";
      }
      this.$emit(`update:${name}`, value);
    }
  }
